import getFormDeclaration from './getFormDeclaration'

export const getFormDeclarationPromise = getFormDeclaration
